import React from "react";
import "../../styles/DashboardSidebar.css";
import {
  FiHome,
  FiSearch,
  FiFileText,
  FiEdit3,
  FiTarget,
  FiFolder,
  FiBriefcase,
  FiSettings,
  FiZap,
} from "react-icons/fi";

export type DashboardView =
  | "dashboard"
  | "job-analyzer"
  | "resume-analyzer"
  | "cv-builder"
  | "cover-letter"
  | "ats-checker"
  | "saved-documents"
  | "applications"
  | "settings";

type Props = {
  activeView: DashboardView;
  onChangeView: (view: DashboardView) => void;
  onUpgrade: () => void;
};

type MenuItem = {
  id: DashboardView;
  label: string;
  icon: unknown;
};

const menuItems: MenuItem[] = [
  { id: "dashboard", label: "Home", icon: FiHome },
  { id: "job-analyzer", label: "Job Analyzer", icon: FiSearch },
  { id: "resume-analyzer", label: "CV Analyzer", icon: FiFileText },
  { id: "cv-builder", label: "CV Builder", icon: FiEdit3 },
  { id: "cover-letter", label: "Cover Letter", icon: FiFileText },
  { id: "ats-checker", label: "ATS Checker", icon: FiTarget },
  { id: "saved-documents", label: "Saved Documents", icon: FiFolder },
  { id: "applications", label: "Applications", icon: FiBriefcase },
  { id: "settings", label: "Settings", icon: FiSettings },
];

function renderIcon(icon: unknown): React.ReactElement {
  return React.createElement(
    icon as React.ComponentType<Record<string, never>>
  );
}

export default function DashboardSidebar({
  activeView,
  onChangeView,
  onUpgrade,
}: Props) {
  return (
    <aside className="dashboard-sidebar">
      <div className="dashboard-sidebar__brand">
        <div className="dashboard-sidebar__logo">
          {renderIcon(FiFileText)}
        </div>

        <div className="dashboard-sidebar__brand-text">
          <span>JobTailor</span>
          <strong>AI</strong>
        </div>
      </div>

      <nav className="dashboard-sidebar__nav">
        {menuItems.map((item) => {
          const active = activeView === item.id;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChangeView(item.id)}
              className={`dashboard-sidebar__item ${
                active ? "dashboard-sidebar__item--active" : ""
              }`}
            >
              <span className="dashboard-sidebar__item-icon">
                {renderIcon(item.icon)}
              </span>

              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="dashboard-sidebar__upgrade">
        <div className="dashboard-sidebar__upgrade-title">
          {renderIcon(FiZap)}
          <span>Upgrade to Pro</span>
        </div>

        <p>Unlock unlimited analyses and more powerful features.</p>

        <button type="button" onClick={onUpgrade}>
          Upgrade Now
        </button>
      </div>
    </aside>
  );
}